import { GET_BY_ID, SESSION_MODULE } from '@inpart-io/devtools-vue';
import { LeadStatus } from '@inpart-io/padme-iap';

import { LeadStatusSet } from '@/components/lead-profile/components/lead-status/constants/lead.status.constants';
import { store } from '@/store/index';
import { LEAD_STATUS_CONFIGURATION_MODULE } from '@/store/lead-status-configuration-module';
import { GET_FROM_STATUS } from '@/store/lead-status-configuration-module/getters';
import { USE_DEAL_WORKFLOW } from '@/store/session-module/getters';
import { TEMPLATE_DEAL_STAGE_MODULE } from '@/store/template-deal-stage-module';

export class TranslationService {
    public getLeadStatusLabel(status: LeadStatus | string): string {
        if (status === LeadStatusSet.CLOSED) {
            if (store.getters[`${SESSION_MODULE}/${USE_DEAL_WORKFLOW}`]) {
                status = LeadStatus.CLOSED;
            } else {
                status = LeadStatus.QUALIFIED;
            }
        }
        return store.getters[`${LEAD_STATUS_CONFIGURATION_MODULE}/${GET_FROM_STATUS}`](status)?.name ?? status;
    }

    public getLeadStageLabel(templateId: number): string {
        return store.getters[`${TEMPLATE_DEAL_STAGE_MODULE}/${GET_BY_ID}`](templateId).name;
    }
}

export const translationService = new TranslationService();
